import { render, staticRenderFns } from "./EditExpense.vue?vue&type=template&id=60224fd7"
import script from "./EditExpense.vue?vue&type=script&setup=true&lang=js"
export * from "./EditExpense.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EditExpense.vue?vue&type=style&index=0&id=60224fd7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports